import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import LinksPagamento from './links_pagamento';
import utils from './utils';

export default function DialogLinksPagamento(props) {
  const { open, onClose, id_hub_ped_venda_pgto, crud } = props;

  return (
    <Dialog open={Boolean(open)} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>{utils.lng('links_pagamento', 'Links de pagamento')}</DialogTitle>
      <DialogContent>
        <LinksPagamento id_hub_ped_venda_pgto={id_hub_ped_venda_pgto} crud={crud} />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" className="split-btn-fechar" onClick={onClose}>
          {utils.lng('fechar', 'Fechar')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
